import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { pricing } from '../data/sushiContent';
export function MidPageCta() {
  return <section className="w-full border-y border-champagne/25 bg-charcoal-950 py-12 sm:py-14" aria-labelledby="mid-cta-title" data-id="element-192" data-mp="3jlm6905oa9o">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-193" data-mp="8hn60w5eodm7">
        <h2 id="mid-cta-title" className="font-display text-[1.5rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2rem]" data-id="element-194" data-mp="37xtlwreu0nb9">
          Ya sabés cómo debería verse tu próxima comida.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-[14px] leading-relaxed text-body sm:text-[15px]" data-id="element-195" data-mp="3gxgkz6k39h15">
          Este es el sistema que la pone en la mesa: 90 páginas, 6 formatos, 40+ recetas
          y 3 bonos. Tu primer sushi casero puede salir hoy.
        </p>

        <p className="mt-6 text-[12px] uppercase tracking-[0.12em] text-muted" data-id="element-196" data-mp="117dotihzg3on">
          <span className="line-through" data-id="element-197" data-mp="1196uaugv0hv2">{pricing.regularPrice}</span>
          <span className="ml-3 font-semibold text-champagne" data-id="element-198" data-mp="1cf234od4l16o">
            Hoy {pricing.today} USD
          </span>
        </p>

        <div className="mt-5 flex justify-center" data-id="element-199" data-mp="18c5rxipx07cr">
          <CtaButton size="md" data-id="element-200" data-mp="13duih93j7yv2" />
        </div>
        <TrustStrip className="mt-3" data-id="element-201" data-mp="13gqgexfdqnji" />
      </div>
    </section>;
}